export function getView(provider_call) {
  if (!provider_call) return 'Ongoing'
  if (provider_call.left_at) return 'DoctorLeft'
  if (provider_call.arrived_at) return 'DoctorArrived'
  if (provider_call.calling_since) return 'CalledDoctor'
  return 'No'
}
